import Image from 'next/image'
import React, { forwardRef } from 'react'
import { useContext } from 'react'
import { isMobileContext } from '../../contexts/isMobileContext'
import { BASE_URL } from '../../utils/FetchData'
import FadeIn from '../Animations/FadeIn'
// eslint-disable-next-line react/display-name
const Landmarks = forwardRef(({ landmarksData, commercialPage }, ref) => {
  const { isMobile } = useContext(isMobileContext);
  return (
    <div className='landmarks-section' ref={ref}
      style={{ background: commercialPage ? "#F7F7F7" : "none" }}
    >
      <FadeIn customClass="header">
        <h2 className='light _eleX'>{landmarksData?.Title}</h2>
        <p className='_eleX'>{landmarksData?.Description}</p>
      </FadeIn>
      <div className="map-container">
        {landmarksData?.Img_Mobile?.data?.attributes?.url &&
          <Image src={BASE_URL + (isMobile ? landmarksData?.Img_Mobile?.data?.attributes?.url : landmarksData?.Img_Desktop?.data?.attributes?.url)} layout="fill"
            alt="map"
            objectFit='cover' />
        }
      </div>
    </div>
  )
})
export default Landmarks